import { useMemo } from 'react';
import { ColumnDescription } from 'react-bootstrap-table-next';

import { AdminIntegration } from '~services/admin/integration/types';
import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import {
  IntegrationTypeInfo,
  IntegrationAccountInfo,
  IntegrationExpirationDateInfo,
} from '~components/index';
import { getBillingListLabelText } from '~utils/billingList';

import { useIntegrationsSectionContext } from '../Context';

import IntegrationsSectionDataTableActionsMenu from './ActionsMenu';

export const useIntegrationsSectionDataTableColumns =
  (): ColumnDescription<AdminIntegration>[] => {
    const { isCarrier } = useTypePartnerCompany();

    const {
      dialogs: {
        renovate: { handleOpen: handleOpenDialogRenovateIntegration },
      },
    } = useIntegrationsSectionContext();

    const columns = useMemo<ColumnDescription<AdminIntegration>[]>(
      () => [
        {
          dataField: 'integrationTypeId',
          text: 'Tipo',
          headerStyle: { width: 300 },
          formatter: (_cell, row) => (
            <IntegrationTypeInfo integrationType={row.integrationTypeId} />
          ),
        },
        {
          dataField: 'description',
          text: 'Cuenta',
          formatter: (_cell, row) => (
            <IntegrationAccountInfo
              name={row.description}
              creationDateTime={row.creationDateTime}
            />
          ),
        },
        {
          hidden: !isCarrier,
          dataField: 'billingListId',
          text: 'Lista de precios',
          formatter: (_cell, row) => {
            if (!row.billingList) {
              return 'Sin asignar';
            }

            return getBillingListLabelText(row.billingList);
          },
          headerStyle: { width: 300 },
        },
        {
          dataField: 'expirationDateTime',
          text: 'Fecha de expiración',
          formatter: (_cell, row) => (
            <IntegrationExpirationDateInfo
              expirationDate={row.expirationDateTime}
              onRenovate={() =>
                handleOpenDialogRenovateIntegration({
                  integrationTypeId: row.integrationTypeId,
                  companyIntegrationId: row.companyIntegrationId,
                  description: row.description,
                  storeId: row.storeId,
                  carrierName: row.carrierName,
                })
              }
            />
          ),
        },
        {
          dataField: 'actions',
          isDummyField: true,
          text: '',
          formatter: (_cell, row) => (
            <IntegrationsSectionDataTableActionsMenu data={row} />
          ),
          headerStyle: { width: 60 },
        },
      ],
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [isCarrier],
    );

    return columns;
  };
